import { render, staticRenderFns } from "./EventResponse.vue?vue&type=template&id=cdd15124&scoped=true&"
import script from "./EventResponse.vue?vue&type=script&lang=ts&"
export * from "./EventResponse.vue?vue&type=script&lang=ts&"
import style0 from "./EventResponse.vue?vue&type=style&index=0&id=cdd15124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd15124",
  null
  
)

export default component.exports